// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDisplayName(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<any>>
) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
